import React from "react";
import axios from "axios";
import PageButton from "../PageButton/PageButton";
import { Link } from "react-router-dom";

//MUI Component
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";

import DatePicker from "react-datepicker";
import "../SearchBar/react-datepicker.css";

//Assets
import gps from "../../assets/icons/gps.png";
import calendar from "../../assets/icons/calendar.png";

//Styles
import "styles/styles.scss";
import "../../styles/GlobalCssSlider.css";

const SearchBar = () => {
  // Calendar state
  const [dateRange, setDateRange] = React.useState([null, null]);
  const [startDate, endDate] = dateRange;

  // Rezise state for the Carousel and the calendar
  const [size, setSize] = React.useState(window.innerWidth);

  const [locations, setLocations] = React.useState([]);

  //AUTOCOMPLETE
  const [city, setCity] = React.useState(null);
  const loading = locations.length === 0;

  let path = "";
  if (city && startDate && endDate) {
    path = `city/${city.city}/dates/${startDate
      .toISOString()
      .slice(0, 10)}/${endDate.toISOString().slice(0, 10)}`;
  } else if (city) {
    path = `city/${city.city}`;
  } else if (startDate && endDate) {
    path = `dates/${startDate.toISOString().slice(0, 10)}/${endDate
      .toISOString()
      .slice(0, 10)}`;
  }

  //API TO GET LOCATIONS
  React.useEffect(() => {
    const fetchLocations = async () => {
      try {
        const resultado = await axios(
          `${process.env.REACT_APP_ROOT_BACKEND_ENDPOINT}/locations`
        );
        setLocations(resultado.data);
      } catch (error) {
        console.log(error.message);
      }
    };
    fetchLocations();
  }, []);
  // Resize function for calendar
  React.useLayoutEffect(() => {
    function updateSize() {
      setSize(window.innerWidth);
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return (
    <>
      <div className="searchBar__container">
        <h2 className="searchBar__container__title">
          Busca ofertas en vehículos y mucho más
        </h2>
        <form className="searchBar__container__form" action="/" method="get">
          <div className="searchBar__container__form__select">
            <Autocomplete
              value={city}
              onChange={(event, newValue) => {
                setCity(newValue);
              }}
              id="city-select"
              size="small"
              sx={{ width: "100%", borderRadius: "5px" }}
              options={locations}
              loading={loading}
              autoHighlight
              getOptionLabel={(option) => option.city + ", " + option.country}
              renderOption={(props, option) => (
                <Box
                  component="li"
                  sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                  {...props}
                >
                  <img width="7%" src={gps} alt="gpsIcon" />
                  <div className="searchBar__container__form__select__options">
                    <p className="searchBar__container__form__select__options__city">
                      {option.city}
                    </p>
                    <p className="searchBar__container__form__select__options__country">
                      {option.country}
                    </p>
                  </div>
                </Box>
              )}
              renderInput={(params) => (
                <Box
                  sx={{
                    paddingLeft: 1,
                    paddingBottom: 1,
                    paddingRight: 1,
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <img src={gps} alt="gpsIcon" />

                  <TextField
                    sx={{ color: "green" }}
                    {...params}
                    color="warning"
                    variant="standard"
                    placeholder="¿A dónde vamos?"
                    InputLabelProps={{
                      sx: { fontSize: 20 },
                    }}
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: "new-password",
                    }}
                  />
                </Box>
              )}
            />
          </div>
          <div className="searchBar__container__form__calendar">
            <img src={calendar} alt="calendar" />
            <DatePicker
              placeholderText="Check In - Check Out"
              selectsRange={true}
              startDate={startDate}
              endDate={endDate}
              onChange={(update) => {
                setDateRange(update);
              }}
              isClearable={true}
              peekNextMonth={true}
              monthsShown={size <= 745 ? 1 : 2}
              minDate={new Date()}
            />
          </div>
          {path ? (
            <Link to={path}>
              <PageButton
                className="searchBar__container__form__submitButton"
                label="Buscar"
              />
            </Link>
          ) : (
            <PageButton
              disabled
              className="searchBar__container__form__submitButton"
              label="Buscar"
            />
          )}
        </form>
      </div>
    </>
  );
};

export default SearchBar;
